import React from "react";
import DatePicker from "react-datepicker";
import {
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Button,
  Card,
  CardBody,
} from "reactstrap";
import "react-datepicker/dist/react-datepicker.css";

const DateIntervalPicker = ({
  currentInterval,
  setCurrentInterval,
  noEndDate,
  setNoEndDate,
  handleCloseInterval,
  calculateEndDate,
}) => {
  return (
    <Card className="border-0 shadow-sm mb-4">
      <CardBody className="p-4">
        {/* Header Section */}
        <div className="mb-4">
          <div className="d-flex align-items-center gap-3 mb-2">
            <h5 className="mb-0 text-dark">Set Schedule Period</h5>
          </div>
          <p
            className="text-secondary mb-0 mt-2"
            style={{ fontSize: "0.9rem" }}
          >
            Define the time period for your available scheduling slots
          </p>
        </div>

        {/* Date Picker Section */}
        <div className="date-interval-container bg-light rounded p-4">
          <Row className="align-items-center">
            <Col md={2}>
              <h6 className="text-secondary mb-0">Date Range</h6>
            </Col>

            <Col md={3}>
              <div className="position-relative">
                <DatePicker
                  dateFormat="dd/MM/yyyy"
                  className="form-control border"
                  name="startDate"
                  placeholderText="From"
                  selected={
                    currentInterval.startDate
                      ? new Date(currentInterval.startDate)
                      : null
                  }
                  onChange={(date) => {
                    if (
                      date.getTime() &&
                      currentInterval.endDate &&
                      currentInterval.endDate < date.getTime()
                    ) {
                      setCurrentInterval((prev) => ({
                        ...prev,
                        startDate: date
                          ? new Date(date.getTime()).setHours(0, 0, 0, 0)
                          : null,
                        endDate: calculateEndDate(date, 30).getTime(),
                      }));
                    } else {
                      setCurrentInterval((prev) => ({
                        ...prev,
                        startDate: date
                          ? new Date(date.getTime()).setHours(0, 0, 0, 0)
                          : null,
                      }));
                    }
                  }}
                />
                <div
                  className="position-absolute"
                  style={{
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    pointerEvents: "none",
                  }}
                >
                  <img
                    src={require("../../assets/images/date_range.svg")}
                    alt="calendar"
                    style={{ width: "18px", height: "18px" }}
                  />
                </div>
              </div>
            </Col>

            <Col md={3}>
              <div className="position-relative">
                <DatePicker
                  dateFormat="dd/MM/yyyy"
                  selected={
                    currentInterval.endDate
                      ? new Date(currentInterval.endDate)
                      : null
                  }
                  minDate={
                    currentInterval.startDate
                      ? new Date(currentInterval.startDate)
                      : null
                  }
                  className="form-control border"
                  name="endDate"
                  placeholderText="To"
                  disabled={noEndDate}
                  onChange={(date) => {
                    setCurrentInterval((prev) => ({
                      ...prev,
                      endDate: date
                        ? new Date(date.getTime()).setHours(0, 0, 0, 0)
                        : null,
                    }));
                  }}
                />
                <div
                  className="position-absolute"
                  style={{
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    pointerEvents: "none",
                  }}
                >
                  <img
                    src={require("../../assets/images/date_range.svg")}
                    alt="calendar"
                    style={{ width: "18px", height: "18px" }}
                  />
                </div>
              </div>
            </Col>

            <Col md={4}>
              <Button
                color="warning"
                className="px-4 text-white"
                onClick={handleCloseInterval}
                disabled={
                  !currentInterval.startDate ||
                  (!currentInterval.endDate && !noEndDate)
                }
              >
                Add Interval
              </Button>
            </Col>
          </Row>

          <Row className="mt-3">
            <Col md={2}></Col>
            <Col md={6}>
              <FormGroup check className="mb-0">
                <Label
                  check
                  className="text-secondary d-flex align-items-center gap-2"
                >
                  <Input
                    type="checkbox"
                    id="noEndDate"
                    style={{ cursor: "pointer" }}
                    onChange={(e) => {
                      setNoEndDate(e.target.checked);
                      if (e.target.checked) {
                        setCurrentInterval((prev) => ({
                          ...prev,
                          endDate: null,
                        }));
                      } else {
                        setCurrentInterval((prev) => ({
                          ...prev,
                          endDate: calculateEndDate(
                            currentInterval.startDate
                              ? currentInterval.startDate
                              : new Date(),
                            30
                          ).getTime(),
                        }));
                      }
                    }}
                    checked={noEndDate}
                  />
                  <span style={{ fontSize: "0.9rem" }}>No End Date</span>
                </Label>
              </FormGroup>
            </Col>
          </Row>
        </div>
      </CardBody>
    </Card>
  );
};

export default DateIntervalPicker;
